class RedirectModal extends HTMLElement {
  constructor() {
    super();
    this.geolocationCountry = null;

    this.addEventListener("toggle", (event) => {
      if (event.newState === "open") {
        this.handleModalOpen();
      } else {
        this.handleModalClose();
      }
    });

    this.querySelectorAll(".redirect-btn").forEach((redirect) => {
      redirect.addEventListener("click", () => {
        this.handleModalClose();
      });
    });
  }

  connectedCallback() {
    fetch("/browsing_context_suggestions.json")
      .then((response) => response.json())
      .then((result) => {
        this.geolocationCountry = result.detected_values?.country;
        this.updateGeolocationValues();

        const geolocationHandle = this.geolocationCountry?.handle;
        const currentCountry = this.dataset.currentCountry;
        const availableCountries = this.dataset.availableCountries.split(",");

        const modalDismissed = localStorage.getItem("redirect-modal-dismissed");

        if (
          modalDismissed ||
          !currentCountry ||
          !geolocationHandle ||
          !availableCountries.length ||
          !availableCountries.includes(geolocationHandle)
        ) {
          return;
        }

        if (geolocationHandle != currentCountry) {
          const currentUrl = new URL(window.location);
          currentUrl.searchParams.delete("country");
          history.replaceState({}, "", currentUrl);

          this.showPopover();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleModalOpen() {
    trapFocus(this);

    document.body.style.setProperty("overflow", "hidden");
    document.getElementById("MainContent")?.setAttribute("inert", true);

    this.setAttribute("aria-modal", true);
    this.focus();
  }

  handleModalClose() {
    removeTrapFocus(this);
    localStorage.setItem(
      "redirect-modal-dismissed",
      this.geolocationCountry.handle
    );

    document.body.style.removeProperty("overflow");
    document.getElementById("MainContent")?.removeAttribute("inert");

    this.removeAttribute("aria-modal");
  }

  updateGeolocationValues() {
    const countryNames = this.querySelectorAll(".country-name");
    const countryCodes = this.querySelectorAll(".country-code");
    const countryInput = this.querySelectorAll(".country-input");

    countryNames.forEach((name) => {
      name.innerHTML = this.geolocationCountry.name;
    });

    countryCodes.forEach((code) => {
      code.innerHTML = this.geolocationCountry.handle;
    });

    countryInput.forEach((input) => {
      input.setAttribute("value", this.geolocationCountry.handle);
    });
  }
}

customElements.define("redirect-modal", RedirectModal);
